/* @flow */

'use strict';

exports.__esModule = true;
exports['default'] = prefixPlugin;

var _prefixer = require('../prefixer');

/*:: import type {PluginConfig, PluginResult} from '.';*/
function prefixPlugin(_ref /*: PluginConfig*/) /*: PluginResult*/ {
  var componentName = _ref.componentName;
  var config = _ref.config;
  var style = _ref.style;

  var newStyle = _prefixer.getPrefixedStyle(style, componentName, config.userAgent);
  return { style: newStyle };
}

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/radium/lib/plugins/prefix-plugin.js
 ** module id = 203
 ** module chunks = 0
 **/